import React from 'react';
import Sidebar from './Sidebar';

const Layout = ({ children }) => {
    return (
        <div className="flex h-screen overflow-hidden bg-slate-100 text-text-dark font-sans">
            <Sidebar />
            <main className="flex-grow overflow-y-auto p-4 md:p-10">
                {children}
            </main>
        </div>
    );
};

export default Layout;
